<template>
  <div id="event-live-donation" class="width: 0px;">
    <div class="pg-event-live-donation--wrap--image__little">
      <img src="" class="pg-event-live-donation--image__little"></img>
      <div class="pg-event-live-donation--section--item--text--wrap">
        <p class="select-event-live-donation-label-name"></p>
        <p class="select-event-live-donation-label-price"></p>
      </div>
    </div>
    <div class="pg-event-live-donation--section--item--text--wrap--full">
      <p class="select-event-live-donation-label-overview"></p>
    </div>
    <div id="payment-form">
      <div class="pg-event-live-donation--wrap--name__form">
        <input type="text" name="fromName" maxlength="30" class="pg-event-live-donation--form--name" v-model="fromUseaname" placeholder="あなたの名前（任意）">
        <span class="pg-event-live-donation--form--name--suffix">から</span>
        <select class="pg-event-live-donation--dropdown to_user_name" v-model="toUseName" style="-webkit-appearance: auto;">
          <option v-for="performer in performers" v-bind:value="performer.name">
            {{ performer.name }}
          </option>
        </select>
        <span class="pg-event-live-donation--form--name--suffix">へ</span>
        <textarea name="message" maxlength="50" class="pg-event-live-donation--form--message donation_message" v-model="donationMessage" placeholder="メッセージ（５０文字以内）"></textarea>
      </div>
      <input type="hidden" name="formSkuId" value="" class="select-event-live-donation-sku_id">
      <div class="payment-errors"></div>
      <p class="pg-event-live-donation-label-credit">クレジットカード決済</p>
      <div class="input-form-section">
        <div class="input-form" style="margin-top: 0;">
          <div class="form-row">
            <div class="pg-event-live-donation-wrap-label-form-label">
              <label for="card-number-element" class="pg-event-live-donation-label-form-label">カード番号</label>
              <div class="pg-event-live-donation--wrap--stripe__form">
                <div id="card-number-element" class="pg-event-live-donation--input-stripe"></div>
              </div>
            </div>
            <div class="pg-event-live-donation-wrap-label-form-label--half">
              <div class="pg-event-live-donation-wrap-label-form-label">
                <label for="card-expiry-element" class="pg-event-live-donation-label-form-label-half">有効期限（月 / 年）</label>
                <div id="card-expiry-element" class="pg-event-live-donation--input-stripe--half"></div>
              </div>
              <div class="pg-event-live-donation-wrap-label-form-label">
                <label for="card-cvc-element" class="pg-event-live-donation-label-form-label-half pg-event-live-donation-label-form-label-half_margin">セキュリティコード</label>
                <div id="card-cvc-element" class="pg-event-live-donation--input-stripe--half pg-event-live-donation-label-form-label-half_margin-only-pc"></div>
              </div>
            </div>
            <div id="card-errors" role="alert" class="pg-event-live-donation--label--error"></div>
            <div class="pg-event-live-section-space-10px"></div>
            <input type="hidden" id="use_existing_card" v-model="use_existing_card">
          </div>
          <div class="form-row">
            <input type="checkbox" name="save_flg" id="save_flg" class="save_card_info" checked="checked">
            <label class="pg-event-live-donation-label-form-label-full">カード情報を保存する</label>
          </div>
        </div>
      </div>
      <div class="pg-event-live-donation--wrap--stripe__approval">
        <input type="checkbox" v-model="approvaled" value="ok" class="approval-donatipon">
        <label style="margin-bottom: 0;">利用規約・特約に同意の上、購入内容を確認しました</label>
      </div>
      <div class="pg-event-live-donation--wrap--buttons">
        <input id="doDonationButton" type="button" :disabled="!approvaled" class="submit button-blue center-button pg-event-live-donation--button" value="購入して応援する">
        <div id="removeDonationButton" class="submit button-blue center-button pg-event-live-donation--button--dark" v-on:click="removeDonationSection()">閉じる</div>
      </div>
    </div>
    <!-- 投げ銭実行中 -->
    <template v-if="donationStatus == consts.EVENT_LIVE_DONATION_STSTUS.DONATING">
      <div id="event-live-donation--state--processing">
        <div class="event-live-donation--state--processing--label--headline__green">
          <p>応援ありがとうございます！</p>
        </div>
        <div class="event-live-donation--state--processing--label--normal">
          <p>{{fromUsernameDIspText()}}</p>
          <p>{{toUseName}}さんに</p>
          <p>お届け中です...</p>
        </div>
        <div class="event-live-donation--state--processing--label--normal">
          <p class="event-live-donation--state--processing--label--alart">画面を閉じずにお待ちください</p>
        </div>
      </div>
    </template>
    <!-- 投げ銭実行後 -->
    <template v-if="donationStatus == consts.EVENT_LIVE_DONATION_STSTUS.BEFORE_LISTING">
      <div id="event-live-donation--state--complete">
        <div class="event-live-donation--state--processing--label--headline__green">
          <p>応援ありがとうございました！</p>
        </div>
        <div class="event-live-donation--state--processing--label--normal" style="margin-bottom: 30px;">
          <p>{{fromUsernameDIspText()}}</p>
          <p>{{toUseName}}さんに</p>
          <p>届けました！</p>
        </div>
        <template v-if="event_name.length > 0 && event_path.length > 0">
          <div class="event-live-donation--state--processing--label--normal" style="margin-bottom: 30px;">
            <a class="pg-event-live-donation--button--twitter_share" v-bind:href="tweetUrl()" v-bind:data-text="tweetDataText()" data-lang="ja" data-app="twitter" target="_blank">
              <img v-bind:src="require('assets/images/logo-x-black.png')" class="pg-event-live-donation--img--twitter">
              応援したとシェア！
            </a>
          </div>
        </template>
        <div id="removeDonationButton" class="pg-event-live-donation--button--dark--full submit button-blue center-button" v-on:click="removeDonationSectionAndInit()"><div class="pg-event-live-donation--label--in_dark--full">閉じる</div></div>
      </div>
    </template>
    <!-- 投げ銭失敗(未決済) -->
    <template v-if="donationStatus == consts.EVENT_LIVE_DONATION_STSTUS.FAIL_BEFORE_CHARGE">
      <div id="event-live-donation--state--fail-before-charge">
        <div class="event-live-donation--section--fail--message">
          <div class="event-live-donation--state--processing--label--headline__bold__black">
            <p>決済に失敗しました。</p>
          </div>
          <div class="event-live-donation--state--processing--label--thin__black">
            <p>お手数をおかけいたしますが、以下の原因をお確かめの上、再度お試しください。</p>
          </div>
          <div class="event-live-donation--state--processing--label--bold__black">
            <p>・カード情報が誤って登録されている</p>
            <p>・カードのご利用が制限されている</p>
            <p>・インターネット回線が途切れた</p>
          </div>
        </div>
        <div id="removeDonationButton" class="pg-event-live-donation--button--dark--full submit button-blue center-button" v-on:click="removeDonationSectionAndInit()"><div class="pg-event-live-donation--label--in_dark--full">閉じる</div></div>
      </div>
    </template>
    <!-- 投げ銭失敗(決済済) -->
    <template v-if="donationStatus == consts.EVENT_LIVE_DONATION_STSTUS.FAIL_AFTER_CHARGE">
      <div id="event-live-donation--state--fail-after-charge">
        <div class="event-live-donation--section--fail--message">
          <div class="event-live-donation--state--processing--label--headline__bold__black">
            <p>決済に失敗しました。</p>
          </div>
          <div class="event-live-donation--state--processing--label--thin__black">
            <p>お手数をおかけいたしますが、以下のボタンを押してください。</p>
            </br>
            <p>ボタンを押してもこの画面が表示され続ける場合は、<div v-html="contact_link"></div></p>
          </div>
        </div>
        <div class="submit button-blue center-button pg-event-live-donation--button--blue--full" v-on:click="retryDonation()">問題を解決する</div>
      </div>
    </template>
  </div>
</template>

<script>
  import {db} from '../utils/firebase'
  import firebase from "firebase/app"
  import consts from '../utils/consts'
  import axios from "axios";

  export default {
    name: "EventLiveDonation",
    props: {
      ttsid: { type: String, required: true },
      uimage: { type: String, required: true },
      uname: { type: String, required: true },
      userid: { type: String, required: true },
      stkey: { type: String, required: true },
      donation_api_path: { type: String, required: true },
      card_number: { type: String, required: true },
      exp_date: { type: String, required: true },
      cvc: { type: String, required: true },
      performers: { type: Array, required: true },
      event_name: { type: String, required: true },
      event_path: { type: String, required: true },
      use_existing_card: { type: Boolean, required: true },
      stripe_font_color: { type: String, required: true },
      contact_link: { type: String, required: true },
    },
    data: () => ({
      approvaled: false,
      donationStatus: consts.EVENT_LIVE_DONATION_STSTUS.BEFORE_DONATION,
      toUseName: "",
      fromUseaname: "",
      donationMessage: "",
      errorTmp: "",
      stripeToken: "",
      lastDonatedSkuTweetImg: "",
    }),
    firestore() {
    },
    computed: {
      consts: function() {
        return consts
      }
    },
    methods: {
      removeDonationSectionAndInit: function(){
        this.donationStatus = consts.EVENT_LIVE_DONATION_STSTUS.BEFORE_DONATION
        this.removeDonationSection()
      },
      tweetUrl: function(){
        return "https://twitter.com/intent/tweet?url=" + this.event_path + "%20" + this.lastDonatedSkuTweetImg + "&text=" + this.event_name + "で" + this.toUseName + "を応援しました！" + "&via=tigetnet&hashtags=TIGET&related=tigetnet"
      },
      tweetDataText: function(){
        return this.event_name
      },
      fromUsernameDIspText: function() {
        var _fromUsename = ""
        if(this.fromUseaname.length > 0){
          _fromUsename = this.fromUseaname  + "さんの"
        } else {
          _fromUsename = "あなたの"
        }
        return _fromUsename + "気持ちを"
      },
      retryDonation: function() {
        this.donationStatus = consts.EVENT_LIVE_DONATION_STSTUS.DONATING
        setTimeout(function(){
          setCustomStyle('#event-live-donation')
        }, 100);
        var donationRes = null
        axios.post(this.donation_api_path + "?rid=" + this.errorTmp, {
          stripeToken: this.stripeToken,
          save_flg: false
        }).then(res => {
          donationRes = res
          if (!this.setDonatonStatusFromRes(res)){return}
          this.lastDonatedSkuTweetImg = res.data.data.ticket_type_streaming_donation.sku_tweet_img_url
          this.sendFirebase(res.data.data.ticket_type_streaming_donation)
        }).catch(function(error) {
          if (donationRes != undefined && donationRes != null) {
            this.setDonatonStatusFromRes(donationRes)
          } else {
            this.donationStatus = consts.EVENT_LIVE_DONATION_STSTUS.FAIL_BEFORE_CHARGE
            setTimeout(function(){
              setCustomStyle('#event-live-donation')
            }, 100);
          }
        });
      },
      setDonatonStatusFromRes: function(res){
        var resStatus = -1
        var resData = null

        // レスポンスから値を設定
        if(res != undefined && res.data != undefined && res.data.status != undefined ){
          resStatus = res.data.status
        }
        if(res != undefined && res.data != undefined && res.data.data != undefined && res.data.data.ticket_type_streaming_donation != undefined ){
          resData = res.data.data.ticket_type_streaming_donation
        }
        // 形式不正
        if (resStatus == -1 || resData == null || resStatus == consts.API.FAIL_BAD_REQUEST) {
          // 決済が行われていないと判定
          this.donationStatus = consts.EVENT_LIVE_DONATION_STSTUS.FAIL_BEFORE_CHARGE
          setTimeout(function(){
            setCustomStyle('#event-live-donation')
          }, 100);
          return false
        }
        // 決済前エラー
        if (resStatus == consts.API.FAIL_BEFORE_CHARGE) {
          this.donationStatus = consts.EVENT_LIVE_DONATION_STSTUS.FAIL_BEFORE_CHARGE
          setTimeout(function(){
            setCustomStyle('#event-live-donation')
          }, 100);
          return false
        }
        // 決済後エラー
        if (resStatus == consts.API.FAIL_AFTER_CHARGE) {
          if (resData != undefined && resData != null && resData.tmp != undefined && resData.tmp.confirm != true) {
            // 未確定、かつ、tmp発行済みの場合はリトライ
            this.donationStatus = consts.EVENT_LIVE_DONATION_STSTUS.FAIL_AFTER_CHARGE
            setTimeout(function(){
              setCustomStyle('#event-live-donation')
            }, 100);
            this.errorTmp = resData.tmp
            this.stripeToken = resData.payment_token
          } else {
            // 決済が行われていないと判定
            this.donationStatus = consts.EVENT_LIVE_DONATION_STSTUS.FAIL_BEFORE_CHARGE
            setTimeout(function(){
              setCustomStyle('#event-live-donation')
            }, 100);
          }
          return false
        }
        // 決済完了と判定
        this.donationStatus = consts.EVENT_LIVE_DONATION_STSTUS.BEFORE_LISTING
        setTimeout(function(){
          setCustomStyle('#event-live-donation')
        }, 100);
        this.errorTmp = ""
        return true
      },
      sendFirebase: function(resData){
        db.collection(consts.EVENT_LIVE_DONATION_STSTUS.PARENT_COLLECTION).doc(this.ttsid).collection(consts.EVENT_LIVE_DONATION_STSTUS.CHILD_COLLECTTION).add({
          uId: resData.user_id,
          to_user_name: resData.to_user_name,
          from_user_name: resData.from_user_name,
          donation_message: resData.message,
          avatar: resData.image_url,
          tmp: resData.tmp,
          price: resData.amount,
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
          updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
        })
      },
      removeDonationSection: function(){
        if((!$(event.target).closest('.event-live-donation-item-list--row').length && !$(event.target).closest('#event-live-donation').length && !$(event.target).closest('.pg-event__ordering__modal__button').length) || $(event.target).attr("id") == 'removeDonationButton') {
          $('.pg-event-live-donation--label--error').text('')
          $('.pg-event-live-donation--image__little').attr('src', '')
          $('.select-event-live-donation-sku_id').val('')
          $('.select-event-live-donation-label-name').text('')
          $('.select-event-live-donation-label-overview').text('')
          $('.select-event-live-donation-label-price').text('')
          this.donationMessage = ""
          this.approvaled = false
          var animationSpeed = 150;
          if(PC_MIN_WIIDTH > window.innerWidth){
            $('#event-live-donation').animate({height:"0px"}, animationSpeed, "linear")
            $('#event-live-donation--state--processing').animate({height:"0px"}, animationSpeed, "linear")
            $('#event-live-donation--state--complete').animate({height:"0px"}, animationSpeed, "linear")
            $('#event-live-donation--state--fail-before-charge').animate({height:"0px"}, animationSpeed, "linear")
            if(!$('#event-live-donation--state--fail-after-charge').is(':visible')){
              $('#event-live-donation--state--fail-after-charge').animate({height:"0px"}, animationSpeed, "linear")
            }
          } else {
            $('#event-live-donation').animate({width:"0px"}, animationSpeed, "linear")
            $('#event-live-donation--state--processing').animate({width:"0px"}, animationSpeed, "linear")
            $('#event-live-donation--state--complete').animate({width:"0px"}, animationSpeed, "linear")
            $('#event-live-donation--state--fail-before-charge').animate({width:"0px"}, animationSpeed, "linear")
            $('#event-live-donation--state--fail-after-charge').animate({width:"0px"}, animationSpeed, "linear")
          }
          setTimeout(function(){
            $('.event-live-donation--wrap').hide()
          }, animationSpeed + 100);
        }
      },
    },
    watch: {
    },
    created(){
    },
    mounted: function () {
      setCustomStyle('#event-live-donation')
      // Stripe設定
      var stripe = Stripe(this.stkey)
      var elements = stripe.elements()
      // function内で使用するため退避
      var $this = this
      var $firebase = firebase

      // 初期値設定
      this.fromUseaname = this.uname
      if(1 > this.performers.length) {
        this.performers[0] =  {name: "出演者"}
      }
      this.toUseName = this.performers[0].name

      // ボタンの入れ替え
      if (PC_MIN_WIIDTH > window.innerWidth){
        $('.pg-event-live-donation--button--dark').after($('.pg-event-live-donation--button'))
      }

      // Stripe設定
      var fontSize = '13px'
      if (PC_MIN_WIIDTH > window.innerWidth){
        fontSize =  '16px'
      }
      var font_color = "#32325d"
      if ($this.stripe_font_color.length > 0) {
        font_color = $this.stripe_font_color
      }
      var style = {
        base: {
          color: font_color,
          fontSize: fontSize,
          padding: '0 0 0 30px',
          lineHeight: '33px'
        },
        invalid: {
          iconColor: '#FF0000',
          color: '#FF0000',
        }
      };

      var cardNumberElement = elements.create('cardNumber', {
        placeholder: $this.card_number,
        style: style
      });
      cardNumberElement.mount('#card-number-element')

      var cardExpiryElement = elements.create('cardExpiry', {
        placeholder: $this.exp_date,
        style: style
      });
      cardExpiryElement.mount('#card-expiry-element')

      var cardCvcElement = elements.create('cardCvc', {
        placeholder: $this.cvc,
        style: style
      });
      cardCvcElement.mount('#card-cvc-element')

      cardExpiryElement.on('change', function(event) {
        clearErrorMsg()
        useNewCard()
      });

      cardCvcElement.on('change', function(event) {
        clearErrorMsg()
        useNewCard()
      });

      cardNumberElement.on('change', function(event) {
        clearErrorMsg()
        useNewCard()
      });

      $('.save_card_info').click(function(){
        useNewCard()
      });

      // Create a token when the form is submitted.
      var form = document.getElementById('doDonationButton')
      form.addEventListener('click', function(e) {
        $this.approvaled = false
        $('.approval-donatipon').prop("disabled", true)
        e.preventDefault()
        if ($this.use_existing_card == true) {
          useExistingCard()
        } else {
          createToken()
        }
      });

      function onSubmit(stripeToken) {
        $this.donationStatus = $this.consts.EVENT_LIVE_DONATION_STSTUS.DONATING
        setTimeout(function(){
          setCustomStyle('#event-live-donation')
        }, 10);
        $('.approval-donatipon').prop("disabled", false)
        var image_path = $('.pg-event-live-donation--image__little').attr('src')
        var save_flg = $('#save_flg').prop('checked')

        var donationRes = null
        axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest'
        axios.post($this.donation_api_path, {
          save_flg: save_flg,
          stripeToken: stripeToken,
          ticket_type_streaming_id: Number($this.ttsid),
          sku_id: Number($('.select-event-live-donation-sku_id').val()),
          to_user_name: $this.toUseName,
          from_user_name: $this.fromUseaname,
          donation_message: $this.donationMessage
        }).then(res => {
          donationRes = res
          if (!$this.setDonatonStatusFromRes(res)){return}
          if (!save_flg) {
            // カード入力フォームクリア
            cardNumberElement.clear()
            cardExpiryElement.clear()
            cardCvcElement.clear()
          }
          $this.lastDonatedSkuTweetImg = res.data.data.ticket_type_streaming_donation.sku_tweet_img_url
          $this.sendFirebase(res.data.data.ticket_type_streaming_donation)
        }).catch(function(error) {
          if (donationRes != undefined && donationRes != null) {
            $this.setDonatonStatusFromRes(donationRes)
          } else {
            $this.donationStatus = consts.EVENT_LIVE_DONATION_STSTUS.FAIL_BEFORE_CHARGE
            setTimeout(function(){
              setCustomStyle('#event-live-donation')
            }, 100);
          }
        });
      }

      function stripeTokenHandler(token) {
        // Submit the form:
        onSubmit(token.id)
      };

      function useExistingCard() {
        // Submit the form:
        onSubmit("")
      };

      function createToken() {
        stripe.createToken(cardNumberElement).then(function(result) {
          if (result.error) {
            // Inform the user if there was an error
            var errorElement = document.getElementById('card-errors')
            errorElement.textContent = result.error.message
          } else {
            // Send the token to your server
            stripeTokenHandler(result.token)
          }
        });
      }

      function useNewCard() {
        $this.use_existing_card = false
        $('is-empty').attr('placeholder', '')
        cardNumberElement.update({placeholder: ''})
        cardExpiryElement.update({placeholder: ''})
        cardCvcElement.update({placeholder: ''})
      }

      function clearErrorMsg(){
        $('.approval-donatipon').prop("disabled", false)
        $('.pg-event-live-donation--label--error').text('')
      }


      $('#foundation').on('click', function(event) {
        $this.removeDonationSection();
      });

    }
  }
</script>

<style lang="scss" scoped>
  @import '../packs/application.css';

  #event-live-donation {
    position: fixed;
    top: 0px;
    right: 0px;
    background-color: #F0F0F0;
    height: 100vh;
    z-index: 103;
    width: 300px;
    padding-top: 20px;
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    overflow-x: hidden;

    @media (max-width: 1000px) {
      width: 100%;
      z-index: 105;
      height: calc(39vh + 50px);
      bottom: 0px;
      top: initial;
    }
  }

  .pg-event-live-donation--section--item--text--wrap {
    width: 240px;
    text-align: left;
    font-size: 13px;

    @media (max-width: 1000px) {
      display: inline-block;
      margin-left: 15px;
    }
  }

  .pg-event-live-donation--section--item--text--wrap--full {
    @extend .pg-event-live-donation--section--item--text--wrap;
    margin: 0 30px;

    @media (max-width: 1000px) {
      width: 318px;
      margin: 0;
    }
  }

  .select-event-live-donation-label-name {
    margin-bottom: 5px;
    @media (max-width: 1000px) {
      text-align: left;
    }
  }

  .select-event-live-donation-label-price {
    @media (max-width: 1000px) {
      text-align: left;
    }
  }

    .select-event-live-donation-label-overview {
      display: inline-block;
      color: #333333;
      margin-top: 11px;
      font-size: 11px;

      @media (max-width: 1000px) {
        display: block;
        text-align: left;
      }
    }

  #event-live-donation--state--processing {
    @extend #event-live-donation;

    z-index: 104;
  }

  #event-live-donation--state--complete {
    @extend #event-live-donation;

    z-index: 105;
  }

  #event-live-donation--state--fail-before-charge {
    @extend #event-live-donation;

    z-index: 106;
    text-align: center;
  }

  #event-live-donation::-webkit-scrollbar {
    display:none;
  }

  #event-live-donation--state--fail-after-charge {
    @extend #event-live-donation;

    z-index: 107;
    text-align: center;
  }

  #payment-form {
    @media (max-width: 1000px) {
      padding: 0;
    }
  }

  .pg-event-live-donation--wrap--image__little {
    display: flex;
    width: 250px;
    text-align: center;
    margin: 0 30px;

    @media (max-width: 1000px) {
      width: 100%;
      margin: 0;
    }
  }

  .pg-event-live-donation--image__little {
    width: 60px;
    height: 60px;
    object-fit: cover;
    background-color: #fff;
    margin-right: 10px;

    @media (max-width: 1000px) {
      vertical-align: top;
      margin-right: 0;
    }
  }

  .select-event-live-donation-name {
    color: #333333;
    margin-top: 11px;
    font-size: 13px;
  }

  .pg-event-live-donation--dropdown {
    width: 180px;
    height: 36px;
    margin-bottom: 6px;
    padding: 0 7px;
    border: solid 1.2px #DCDCDC;
    font-size: 15px;
    line-height: 2;
    font-size: 14px;

    @media (max-width: 1000px) {
      font-size: 16px;
      width: 258px;
      margin-bottom: 10px;
    }
  }

  .elect-event-live-donation-label-price {
    color: #333333;
    margin-top: 11px;
    font-size: 13px;
  }

  .pg-event-live-donation--form--name {
    width: 180px;
    height: 36px;
    padding: 0 10px;
    margin-bottom: 6px;
    border: solid 1.2px #DCDCDC;
    -webkit-appearance: none;
    border-radius: 0;
    font-size: 14px;

    @media (max-width: 1000px) {
      font-size: 16px;
      width: 258px;
      margin-bottom: 10px;
      vertical-align: top;
    }
  }

  .pg-event-live-donation--form--name--suffix{
    width: 47px;
    color: #333333;
    font-size: 11px;
    margin-left: 10px;
    display: inline-block;
    text-align: left;

    @media (max-width: 1000px) {
      margin-top: 10px;
    }
  }

  .pg-event-live-donation--form--message {
    resize: none;
    width: 243px;
    height: 100px;
    padding: 0 10px;
    border: solid 1.2px #DCDCDC;
    -webkit-appearance: none;
    border-radius: 0;
    font-size: 14px;

    @media (max-width: 1000px) {
      font-size: 16px;
      width: 640px
    }

    @media (max-width: 675px) {
      width: 470px
    }

    @media (max-width: 500px) {
      width: 320px;
    }

    @media (max-width: 350px) {
      width: 260px;
    }

  }

  .pg-event-live-donation--wrap--name__form {
    margin-top: 15px;
    text-align: center;

    @media (max-width: 1000px) {
      text-align: left;
    }
  }

  .pg-event-live-donation-label-credit {
    width: 190px;
    font-size: 14px;
    font-weight: 600;
    margin-top: 18px;
    text-align: center;

    @media (max-width: 1000px) {
      text-align: left;
      margin-bottom: 10px;
    }
  }

  .input-form-section {
    margin-left: 30px;
    @media (max-width: 1000px) {
      margin: 0;
    }
  }

  .input-form {
    padding-top: 0 !important;

    @media (max-width: 1000px) {
      margin: 0 !important;
      width: 100% !important;
    }
  }

  .pg-event-live-donation--input-stripe {
    background-color: #FFFFFF;
    width: 240px;
    border: solid 1.2px #DCDCDC;
    height: 36px;
    padding: 0 10px;

    @media (max-width: 1000px) {
      width: 260px;
    }

    @media (max-width: 320px) {
      width: 240px;
    }

  }

  .pg-event-live-donation-wrap-label-form-label--half {
    display: flex;
  }

  .pg-event-live-donation-wrap-label-form-label {
    @media (max-width: 1000px) {
      display: flex;
    }
  }

  .pg-event-live-donation--input-stripe--half {
    @extend .pg-event-live-donation--input-stripe;

    width: 110px;

    @media (max-width: 1000px) {
      width: 90px;
    }

  }

  .pg-event-live-donation--label--error {
    color: #FF0000;
  }

  .pg-event-live-donation--wrap--stripe__label__form__half {
    display: flex;
  }

  .pg-event-live-donation--wrap--buttons {

    @media (max-width: 1000px) {
      display: flex;
    }
  }

  .pg-event-live-donation--button {
    width: 100%;
    margin: 0;
    border-radius: 0;
    cursor: pointer;

    @media (max-width: 1000px) {
      width: 50VW;
    }

    @media (max-width: 320px) {
      min-width: 100px;
    }
  }

  .pg-event-live-donation--button:disabled {
    opacity: 0.5;
  }

  .pg-event-live-donation--button--dark {
    @extend .pg-event-live-donation--button;

    background-color: #666666;
  }

  .pg-event-live-donation--button--dark--full {
    @extend .pg-event-live-donation--button--dark;
    position: fixed;
    bottom: 0px;
    text-align: initial;

    @media (max-width: 1000px) {
      bottom: 0;
      width: 100vw;
    }
  }

  .pg-event-live-donation--label--in_dark--full {
    width: 100%;
    text-align: initial;
    padding: 0 0 0 120px;

    @media (max-width: 1000px) {
      text-align: center;
      padding: 0;
    }
  }

  .pg-event-live-donation--button--blue--full {
    width: 100%;
    position: fixed;
    bottom: 0px;
    text-align: initial;
    margin-bottom: 0px;
    padding: 0 0 0 95px;

    @media (max-width: 1000px) {
      text-align: center;
      padding: 0;
    }
  }

  .pg-event-live-donation--wrap--stripe__approval {
    margin: 30px 30px 110px 30px;
    font-size: 13px;
    display: flex;
    align-items: center;
    justify-content: center;

    @media (max-width: 1000px) {
      margin-left: 0;
      justify-content: left;
    }
  }

  .approval-donatipon {
    min-width: 19px;
    height: 19px;
    margin-right: 10px;
    border: 1px solid #ccc;
  }

  .pg-event-live-donation-label-form-label {
    font-size: 11px;
    width: 110px;

    @media (max-width: 1000px) {
      width: 60px;
      margin-top: 8px;
    }

    @media (max-width: 320px) {
      width: 40px;
    }

  }

  .pg-event-live-donation-label-form-label-full {
    @extend .pg-event-live-donation-label-form-label;

    @media (max-width: 1000px) {
      margin-top: 0;
      width: auto;
    }
  }

  .pg-event-live-donation-label-form-label-half {
    @extend .pg-event-live-donation-label-form-label;

    @media (max-width: 1000px) {
      margin-top: 0;
    }

    @media (max-width: 350px) {
      width: 40px;
    }

  }

  .pg-event-live-donation-label-form-label-half_margin {
    margin-left: 20px;
  }

  .pg-event-live-donation-label-form-label-half_margin-only-pc {
    @extend .pg-event-live-donation-label-form-label-half_margin;

    @media (max-width: 1000px) {
      margin-left: 0;
    }
  }

  .pg-event-live-donation--wrap--stripe__form {
    margin-bottom: 15px;
  }

  .pg-event-live-section-space-10px {
    margin-top: 10px;
  }

  .event-live-donation--state--processing--label--headline__green {
    color: #3C8686;
    text-align: center;
  }

  .event-live-donation--state--processing--label--normal {
    margin-top: 12px;
    color: #333333;
    text-align: center;
  }

  .event-live-donation--state--processing--label--alart {
    font-weight: 600;
    color: #f00;
  }

  .pg-event-live-donation--button--twitter_share {
    display: inline-block;
    border: 1px solid black;
    border-radius: 18px;
    background-color: #FFF;
    color: black;
    width: 236px;
    height: 38px;
    font-weight: 600;
    font-size: 13px;
    line-height: 1.6;
    padding-top: 8px;
    cursor: pointer;
  }

  .pg-event-live-donation--img--twitter {
    width: 20px;
    padding-bottom: 5px;
  }

  .event-live-donation--section--fail--message {
    padding-left: 30px;
    padding-right: 30px;
  }

  .event-live-donation--state--processing--label--headline__bold__black {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 12px;
  }

  .event-live-donation--state--processing--label--thin__black {
    font-size: 12px;
    margin-bottom: 14px;
  }

  .event-live-donation--state--processing--label--bold__black {
    text-align: left;
    font-size: 12px;
    font-weight: 600;
    margin-bottom: 70px;
    padding-left: 20px;

    @media (max-width: 1000px) {
      padding-left: 50px;
    }
  }

</style>
